<script setup>
import VacancyCard from './VacancyCard.vue';
import Pagination from './Pagination.vue';
import VacancyFilterGroup from './VacancyFilterGroup.vue';
import scrollLock from 'scroll-lock';

import { ref, computed, watch } from 'vue';

const props = defineProps(['data']);
const cards = props.data.vacancies;

let filterGroups = {};
for (const [key, value] of Object.entries(props.data.filters)) {
	filterGroups[key] = [];
}
const filterGroupType = ref(filterGroups);

const filteredVacancies = computed(() => {
	let filteredVacancies = cards;
	currentPage.value = 1;

	for (const property in filterGroupType.value) {
		if (filterGroupType.value[property].length) {
			filteredVacancies = filteredVacancies.filter((card) => {
				return filterGroupType.value[property].some((term) => card.terms.includes(term.id));
			});
		}
	}

	return filteredVacancies;
});

const activeFilters = computed(() => {
	let filters = [];
	for (const property in filterGroupType.value) {
		if (filterGroupType.value[property].length) {
			filterGroupType.value[property].forEach((activeFilter) => {
				filters.push({
					id: activeFilter.id,
					value: activeFilter.name,
				});
			});
		}
	}

	return filters;
});

const filterActive = ref(false);

const currentPage = ref(1);
const vacanciesPerPage = 10;

const paginatedVacancies = computed(() => {
	return filteredVacancies.value.slice(
		vacanciesPerPage * (currentPage.value - 1),
		vacanciesPerPage * currentPage.value
	);
});

const pagination = computed(() => {
	return Math.ceil(filteredVacancies.value.length / vacanciesPerPage);
});

function changePage(pageModifier) {
	document.getElementById('vacancies').scrollIntoView();
	currentPage.value = currentPage.value + pageModifier;
}

function setPage(pageNumber) {
	document.getElementById('vacancies').scrollIntoView();
	currentPage.value = pageNumber;
}

function resetFilters() {
	let filterGroups = {};
	for (const [key, value] of Object.entries(props.data.filters)) {
		filterGroups[key] = [];
	}
	filterGroupType.value = filterGroups;
}

function removeFilter(filterToRemove) {
	for (const property in filterGroupType.value) {
		if (filterGroupType.value[property].length) {
			filterGroupType.value[property].forEach((filter, index) => {
				if (filterToRemove == filter.id) {
					filterGroupType.value[property].splice(index, 1);
				}
			});
		}
	}
}

watch(filterActive, async (newValue) => {
	if (newValue) {
		scrollLock.disablePageScroll();
	} else {
		scrollLock.enablePageScroll();
	}
});
</script>

<template>
	<div class="c-vacancy-filter" :class="{ 'is-active': filterActive }">
		<div class="c-vacancy-filter__logo">
			<img :src="props.data.logo" alt="Logo DNFS" />
		</div>
		<button @click="filterActive = false" class="c-vacancy-close-filter">
			<svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path
					d="M1 21L21 1M1 1L21 21"
					stroke="#2E316B"
					stroke-width="1.66667"
					stroke-linecap="round"
					stroke-linejoin="round"
				/>
			</svg>
		</button>
		<a href="#vacancy-container" class="c-button c-button--primary c-vacancy-filter__skip">Ga naar vacatures </a>
		<h2 class="c-vacancy-filter__title">Filters</h2>
		<div class="c-vacancy-filtercollection">
			<VacancyFilterGroup
				:filters="filter"
				:type="key"
				v-for="(filter, key) in props.data.filters"
				v-model="filterGroupType[key]"
			/>
		</div>
	</div>
	<div class="c-vacancy-container" id="vacancy-container">
		<div class="c-vacancy-container__header">
			<h2 class="c-vacancy-container__title">Vacatures ({{ filteredVacancies.length }})</h2>
			<button @click="filterActive = true" class="c-button c-button--primary c-vacancy-open-filter">
				Filters <span v-if="activeFilters.length > 0">({{ activeFilters.length }})</span>
			</button>
		</div>

		<div class="c-vacancy-container__active-filters" v-if="activeFilters.length > 0">
			<button
				v-for="activeFilter in activeFilters"
				@click="removeFilter(activeFilter.id)"
				class="c-vacancy__reset-filter"
			>
				<svg class="icon icon-cross"><use xlink:href="#icon-cross"></use></svg> {{ activeFilter.value }}
			</button>
			<button @click="resetFilters" class="c-vacancy__reset-filter c-vacancy__reset-filter--all">
				<svg class="icon icon-cross"><use xlink:href="#icon-cross"></use></svg> Alles wissen
			</button>
		</div>

		<VacancyCard v-for="card in paginatedVacancies" v-bind="card" />

		<h2 class="c-vacancies__empty" v-if="paginatedVacancies.length == 0">
			Sorry er zijn geen vacatures gevonden. <br />
			Probeer het nogmaals.
		</h2>

		<Pagination
			v-if="filteredVacancies.length > vacanciesPerPage"
			:pages="pagination"
			:currentPage="currentPage"
			@changePage="changePage"
			@setPage="setPage"
		/>
	</div>
</template>
